module.exports = __webpack_public_path__ + "img/left-design-white.de5a242d.png";